<template>
  <div class="container mx-auto mb-10">
    <div class="flex">
      <div>
        <h2 class="text-xl mb-1">Steps</h2>
        <p class="text-gray-500 mb-2">Define steps of this wave.</p>
      </div>
      <div  class="ml-10 flex-1">
        <button
          @click="modals.create = true"
          class="rounded-full bg-yellow-500 text-blue-50 shadow h-10 w-10 flex items-center justify-center text-xl">+</button>
      </div>
    </div>

    <div class="container mx-auto">

      <empty
        v-if="steps.length === 0"
        icon="water"
        title="No step on this wave"
        message="The weather is not optimal for surfing the waves.">
      </empty>

      <div
        v-else-if="steps.length > 0"
        class="-mx-4 sm:-mx-8 px-4 sm:px-8 py-4 overflow-x-auto">
        <div class="inline-block min-w-full shadow rounded-lg overflow-hidden">
          <table class="min-w-full leading-normal">
            <draggable v-model="stepList" group="people" @start="drag=true" @end="drag=false" tag="tbody">
              <tr
                v-for="(step, index) in stepList"
                :key="index">
                <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                  <p class="text-gray-900 whitespace-no-wrap">Etape {{ index + 1 }} : {{ step.title }}</p>
                </td>

                <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm text-right">
                  <span class="relative" style="display:flex;flex-flow:column nowrap;">
                    <span v-if="viewsSteps[index] && viewsSteps[index].views.total">Total views : {{viewsSteps[index].views.total}}</span>
                    <span v-if="viewsSteps[index] && viewsSteps[index].views.unique">Unique views : {{viewsSteps[index].views.unique}}</span>
                  </span>
                </td>

                <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm text-right">
                  <span class="relative inline-block px-3 py-1 leading-tight mr-2" v-for="lang in languages" :key="lang">
                    <span class="absolute inset-0 rounded"
                          :class="{
                            'bg-blue-400' : Object.keys(step.body).includes(lang),
                            'bg-gray-200' : !Object.keys(step.body).includes(lang) && defaultLang !== lang,
                            'bg-red-500' : !Object.keys(step.body).includes(lang) && defaultLang === lang,
                    }"></span>
                    <span class="relative text-white">{{ lang }}</span>
                  </span>
                </td>

                <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm text-right">
                  <button class="text-gray-600 bg-gray-200 rounded p-2" @click="editStep(index)"><font-awesome-icon icon="pencil-alt"></font-awesome-icon></button>
                  <button class="text-gray-600 bg-gray-200 rounded p-2" @click="$emit('deleted-step', index)"><font-awesome-icon icon="trash"></font-awesome-icon></button>
                </td>
              </tr>
            </draggable>
          </table>
        </div>
      </div>

      <waves-ui-modal-step-create
        v-if="modals.create"
        :id="waveId"
        :open="modals.create"
        :csvFields="csvFields"
        @created-step="(step) => {$emit('created-step', step);}"
        @close="modals.create = false"/>

      <waves-ui-modal-step-create
        v-if="modals.edit"
        :id="waveId"
        :open="modals.edit"
        :step="stepToEdit"
        :csvFields="csvFields"
        @created-step="(step) => {$emit('updated-step', step);}"
        @close="modals.edit = false"/>

    </div>
  </div>

</template>

<script>
import Empty from '@/components/box-entity-empty.vue'
import { mapActions, mapGetters } from 'vuex'
import draggable from 'vuedraggable'

export default {
  name: 'WaveStepList',

  components: { Empty, draggable },

  props: {
    steps: {
      type: Array,
      required: true,
      default () { return [] }
    },
    waveId: {
      type: String,
      required: true
    },
    viewsSteps: {
      required: true
    },
    csvFields: {
      type: Array
    }
  },

  data () {
    return {
      stepToEdit: null,
      modals: {
        create: false,
        edit: false
      }
    }
  },

  computed: {
    ...mapGetters('account', {
      site: 'currentSite',
      defaultLang: 'defaultLang'
    }),
    languages() {
      return this.site.languages.map(lang => lang.lang)
    },

    stepList: {
      get () {
        return this.steps
      },
      set (value) {
        this.$emit('updated-order', value)
      }
    }
  },

  methods: {
    ...mapActions('waves', ['addStepWave']),

    editStep (index) {
      this.stepToEdit = this.steps[index]
      this.stepToEdit.index = index
      this.modals.edit = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/waves/ui/form/step-list.vue